import { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import RackDetailModal from "./RackDetailModal";

export default function RackDimensionHeatmap({
    rack,
    details = [],
    onClose
}) {

    const [mode, setMode] = useState("occupancy");

    // popup detail
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [openDetail, setOpenDetail] = useState(false);

    //const totalRows = rack?.total_rows || 0;
    //const totalCols = rack?.total_columns || 0;

    const totalRows =
        rack?.total_rows ||
        rack?.rows ||
        0;

    const totalCols =
        rack?.total_columns ||
        rack?.columns ||
        0;

    /*const filteredDetails = details.filter(
        (d) => d.racking_id === rack.id
    );*/

    const filteredDetails = useMemo(() => {
        if (!Array.isArray(details)) return [];
        return details.flatMap((r) => r.details || []);
    }, [details]);

    // ambil slot berdasarkan row col
    const getSlotData = (row, col) => {
        return filteredDetails.find((d) => {

            if (!d.level_code) return false;

            const [r, c] = d.level_code.split(".");

            return (
                Number(r) === Number(row) &&
                Number(c) === Number(col)
            );
        });
    };

    // ambil semua item dalam slot
    const getSlotItems = (row, col) => {

        return filteredDetails.filter((d) => {

            if (!d.level_code) return false;

            const [r, c] = d.level_code.split(".");

            return (
                Number(r) === Number(row) &&
                Number(c) === Number(col)
            );
        });
    };

    const getColor = (slot) => {

        if (!slot) {
            return "bg-gray-200 text-gray-600";
        }

        if (mode === "expired") {

            if (!slot.due_date) {
                return "bg-green-500 text-white";
            }

            const today = new Date();
            const exp = new Date(slot.due_date);

            const diff =
                (exp - today) / (1000 * 60 * 60 * 24);

            if (diff <= 7) {
                return "bg-red-500 text-white animate-pulse";
            }

            return "bg-green-500 text-white";
        }

        return "bg-green-500 text-white";
    };

    return (
        <>
            <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">

                <div className="bg-white rounded-2xl w-full max-w-7xl shadow-2xl overflow-hidden">

                    {/* HEADER */}
                    <div className="flex justify-between items-center border-b px-6 py-4">

                        <div>
                            <h2 className="text-2xl font-bold">
                                Detail Dimensi Rack
                            </h2>

                            <div className="text-gray-500 text-sm mt-1">
                                {rack?.racks_name} •{" "}
                                {totalRows} Rows × {totalCols} Columns
                            </div>
                        </div>

                        <button
                            onClick={onClose}
                            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg"
                        >
                            Tutup
                        </button>
                    </div>

                    {/* FILTER */}
                    <div className="px-6 py-4 border-b flex gap-3">

                        <button
                            onClick={() => setMode("occupancy")}
                            className={`
                                px-4 py-2 rounded-lg text-sm font-medium
                                ${mode === "occupancy"
                                    ? "bg-blue-500 text-white"
                                    : "bg-gray-200 text-gray-700"}
                            `}
                        >
                            Occupancy
                        </button>
                    </div>

                    {/* GRID */}
                    <div className="p-6 overflow-auto max-h-[75vh] bg-gray-50">

                        <div
                            className="grid gap-4"
                            style={{
                                gridTemplateColumns: `repeat(${totalCols}, minmax(100px, 1fr))`
                            }}
                        >

                            {Array.from({
                                length: totalRows * totalCols
                            }).map((_, index) => {

                                const row =
                                    Math.floor(index / totalCols) + 1;

                                const col =
                                    (index % totalCols) + 1;

                                const slot = getSlotData(row, col);

                                return (
                                    <motion.div
                                        key={`${row}-${col}`}
                                        whileHover={{ scale: 1.04 }}
                                        whileTap={{ scale: 0.98 }}
                                        onClick={() => {

                                            if (!slot) return;

                                            const items =
                                                getSlotItems(row, col);

                                            setSelectedSlot({
                                                row,
                                                col,
                                                items,
                                                level_code: `${row}.${col}`
                                            });

                                            setOpenDetail(true);
                                        }}
                                        className={`
                                            rounded-2xl shadow border
                                            min-h-[110px]
                                            p-3 flex flex-col justify-between
                                            transition-all cursor-pointer
                                            ${getColor(slot)}
                                        `}
                                    >

                                        {/* SLOT */}
                                        <div className="flex justify-between items-start">

                                            <div>
                                                <div className="font-bold text-sm">
                                                   Locator : {row}.{col}
                                                </div>

                                                <div className="text-xs opacity-80">
                                                    
                                                </div>
                                            </div>

                                            {slot && (
                                                <div className="text-xs font-bold">
                                                    Terisi
                                                </div>
                                            )}
                                        </div>

                                        {/* CONTENT */}
                                        {slot ? (
                                            <div className="mt-3">

                                                <div className="text-xs font-semibold truncate">
                                                    {slot.sku || "-"}
                                                </div>

                                                {slot.due_date && (
                                                    <div className="text-[10px] mt-2">
                                                        Exp:
                                                        {" "}
                                                        {slot.due_date}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="text-xs opacity-70">
                                                Empty Slot
                                            </div>
                                        )}
                                    </motion.div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            {/* DETAIL POPUP */}
            <AnimatePresence>
                {openDetail && (
                    <RackDetailModal
                        rack={selectedSlot}
                        data={selectedSlot?.items || []}
                        onClose={() => {
                            setOpenDetail(false);
                            setSelectedSlot(null);
                        }}
                    />
                )}
            </AnimatePresence>
        </>
    );
}